import React, { FC, useRef } from 'react';
import { Panel } from '@component/Panel';
import { handleEscKeyPress } from '@app/react/common/handleEscKeyPress';
import { useWindowScrollPosition } from '@app/react/hooks/useWindowScrollPosition';

export interface FamilycrestSelectPanelProps {
    isOpen: boolean;
    handleClose: () => void;
}

const PanelInner: FC<FamilycrestSelectPanelProps> = ({ handleClose, children }) => {
    const scrollObj = useRef(null);
    useWindowScrollPosition('scroll_familycrest_list', true, scrollObj);

    return (
        <>
            <div
                className="order-parts-help-panel-close"
                onClick={handleClose}
                onKeyPress={handleEscKeyPress(handleClose)}
                role="button"
                tabIndex="0"
            >
                <i className="icon-close" />
            </div>
            <div className="familycrest-list-panel">
                <div className="scrollable" ref={scrollObj}>
                    <div className="familycrest-select-panel-header">
                        <span className="title">家紋の選択</span>
                    </div>
                    {children}
                </div>
            </div>
        </>
    );
};

export const FamilycrestSelectPanel: FC<FamilycrestSelectPanelProps> = ({
    isOpen,
    handleClose,
    children,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <PanelInner handleClose={handleClose}>
            {children}
        </PanelInner>
    </Panel>
);
